import { FlexProps, Flex } from '@chakra-ui/react';

export default function NavButtonsContainer(props: FlexProps) {
  return <Flex as="nav" direction="column" gridGap="6px" {...props} />;
}
